import * as React from 'react';
import { forwardRef } from 'react';

var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
var SvgCurbsideDropoff = function SvgCurbsideDropoff(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    className: "Icon ".concat((props === null || props === void 0 ? void 0 : props.className) || ''),
    ref: ref
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "",
    fillRule: "evenodd",
    d: "M2 5a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2v6.5h.5A1.5 1.5 0 0 1 8 18v1h1.619v-1.008a1.5 1.5 0 0 1-.952-1.397v-1.762a1.5 1.5 0 0 1 1.137-1.456l.778-2.538A2.6 2.6 0 0 1 13.068 9h4.602a2.6 2.6 0 0 1 2.504 1.9l.693 2.479A1.5 1.5 0 0 1 22 14.833v1.762a1.5 1.5 0 0 1-.952 1.397v1.01A1 1 0 0 1 21 21H7.5A1.5 1.5 0 0 1 6 19.5v-1H3a1 1 0 1 1 0-2h1V10a2 2 0 0 1-2-2zm4 0H4v3h2zm6 14h6.667v-.905H12zm.494-7.576a.6.6 0 0 1 .574-.424h4.602a.6.6 0 0 1 .578.439l.53 1.894H11.91zm7.125 5.243a.952.952 0 1 0 0-1.905.952.952 0 0 0 0 1.905M12 15.714a.952.952 0 1 1-1.905 0 .952.952 0 0 1 1.905 0",
    clipRule: "evenodd"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCurbsideDropoff);

export { ForwardRef as default };
